import type { WorkspaceOpenOptions } from '../open-options';

/**
 * Members ask the browser to keep this workspace's data on the device. Guests
 * of an external link and viewers of a shared page are not asked: they come
 * for one page, and the browser's prompt (Firefox) only interrupts them.
 */
export function asksForPersistentStorage(
  openOptions: Pick<WorkspaceOpenOptions, 'isSharedMode' | 'externalDocAccess'>
) {
  return !openOptions.isSharedMode && !openOptions.externalDocAccess;
}
